<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
    }>();
</script>

<template>
    <h3
        data-slot="card-title"
        :class="cn('inline-flex shrink-0 items-center leading-none font-semibold', props.class)"
    >
        <slot />
    </h3>
</template>
